import axiosInstance from './AxiosInstance';

export const uploadStatement = (formData) => {
  return axiosInstance.post('process-statement/upload', formData, {
    timeout: 60000,
  });
};

export const getStatementFiles = () => {
  return axiosInstance.get('process-statement/files');
};

export const getStatementRecords = (params) => {
  return axiosInstance.get('process-statement/list', { params });
};

export const reprocessStatements = (data) => {
  return axiosInstance.post('process-statement/reprocess', data, {
    timeout: 120000,
  });
};

export const reprocessAllStatements = (data) => {
  return axiosInstance.post('process-statement/reprocess-all', data, {
    timeout: 180000,
  });
};

export const getReprocessLogs = (params) => {
  return axiosInstance.get('process-statement/reprocess-logs', { params });
};
